import Vue from 'vue'
import Transformer from '@/transformers/transformer'

const PERMISSIONS = [ 'add', 'view', 'change', 'delete' ]

class PermissionTransformer extends Transformer {
  static fetch({ name, label, verbose_name: verboseName, models }) {
    return {
      name, label, verboseName,
      models: models.map(model => {
        const { permissions } = model
        model.others = permissions
          .filter(permission => PERMISSIONS.every(pp => permission.codename !== pp))
        model.permissions = permissions
        return model
      })
    }
  }
}


export default (type) =>
  Vue.$http.get(`/user/permissions_info/`)
    .then((response) => {
      return PermissionTransformer.fetchCollection(response.data)
    })



// WEBPACK FOOTER //
// ./src/services/account/fetchPermissionsInfo.js